import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "mb-4 text-14px" }


interface Props {
  title:string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    title: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})